module.exports = __webpack_public_path__ + "img/tianjianhu.9b7baaba.png";